import { RoundAccordionContribution } from "./RoundAccordionContribution";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function RoundAccordionPanel(_ref) {
  let {
    contributions
  } = _ref;
  return /*#__PURE__*/_jsxs("div", {
    className: "flex flex-col gap-4 bg-grey-75 rounded-lg p-2 pb-[12px]",
    children: [/*#__PURE__*/_jsxs("div", {
      className: "flex items-center justify-between px-4 font-sans font-medium text-base",
      children: [/*#__PURE__*/_jsx("span", {
        className: "flex-1",
        children: "Project"
      }), /*#__PURE__*/_jsx("span", {
        className: "flex-1 text-center",
        children: "Donation"
      }), /*#__PURE__*/_jsx("div", {
        className: "flex-1"
      })]
    }), contributions.length > 0 && contributions.flat().sort((a, b) => (Number(b.timestamp) || Number.MAX_SAFE_INTEGER) - (Number(a.timestamp) || Number.MAX_SAFE_INTEGER)).map(contribution => /*#__PURE__*/_jsx(RoundAccordionContribution, {
      contribution: contribution
    }, contribution.id))]
  });
}